import { makeStyles } from 'tss-react/mui'
import important from '../utils/important'

export const useStyles = makeStyles()(theme => ({
  mainGrid: {
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      marginLeft: 0,
      marginRight: 0
    }
  },
  appHeader: {
    marginTop: 42,
    maxWidth: '90vw',
    marginLeft: 'auto',
    marginRight: 'auto',
    position: 'relative',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '100vw',
      marginLeft: 0,
      marginRight: 0
    }
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    // marginLeft: 0,
    maxWidth: '90vw',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '100vw',
      marginLeft: 0,
      marginRight: 0
    }
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    [theme.breakpoints.up('lg')]: {
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  // necessary for content to be below app bar
  toolbar: {
    ...theme.mixins.toolbar as any,
    width: '100%',
  },

  searchRow: {
    marginBottom: 10,
    width: '100%'
  },

  textSearchField: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: '10px',

    '& input': {
      paddingRight: '30%'
    },

    '& .MuiInputAdornment-root': {
      height: 55,
      width: 55,
      background: '#00b0ff',
      margin: 0,
      paddingRight: '10px',
      position: 'absolute',
      right: '0',
      maxHeight: 'unset',
      display: 'flex',
      justifyContent: 'center',
      borderTopLeftRadius: 0,
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4,
      borderBottomLeftRadius: 0
    },
    '& .MuiInputAdornment-root svg': {
      color: important(theme.palette.primary.contrastText)
    }
  },

  filterDropdown: {
    marginLeft: 0
  },

  dataTable: {
    [theme.breakpoints.down('lg')]: {
      width: '95vw',
      marginLeft: 'auto',
      marginRight: 'auto',
      flexDirection: 'column'
    }
  },
  pageContent: {
    [theme.breakpoints.down('lg')]: {
      width: '95vw',
      marginLeft: 'auto',
      marginRight: 'auto',
      flexDirection: 'column'
    },

    '& h5.MuiTypography-h5': {
      fontSize: 24
    }
  },

  pagination: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 50
  },

  paginationArrow: {
    color: '#00B0FF'
  },

  pageInfo: {
    color: '#00B0FF',
    textDecoration: 'underline',
    marginLeft: 10,
    marginRight: 10
  },

  pageHeaderBox: {
    [theme.breakpoints.up('lg')]: {
      width: '45%'
    }
  },

  mobileFilters: {
    display: 'flex',
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 20,
    flexDirection: 'column',
    width: '100%'
  },

  filters: {
    display: 'flex',
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 20,
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between'
  },

  filtersGroup: {
    width: '47%'
  },

  filtersGroupColumn: {
    flexDirection: 'column'
  },

  filtersResetButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },

  exportButton: {
    flexShrink: 0,
    borderRadius: '2px'
  },

  exportButtonText: {
    fontWeight: 'bold',
    fontSize: '1 rem'
  },

  qrScanner: {
    height: '240px',
    maxWidth: '320px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },

  qrScannerSwitchCameraButton: {
    display: 'flex',
    padding: '7px',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },

  cancelIcon: {
    position: 'absolute',
    top: '50%',
    right: '65px',
    fontSize: '35px',
    cursor: 'pointer',
    transform: 'translateY(-50%)',
    color: theme.palette.text.primary,
    WebkitTapHighlightColor: 'transparent'
  },

  appVersion: {
    textAlign: 'right',
    paddingRight: '10px'
  }
}))
